import type { ResolverInput, ResolverResult } from './types';

// §1.1: migrated to RPC. has_invoice checks status NOT IN
// ('cancelled','draft') — same effective set as the previous direct-DB
// query that checked status IN ('sent','viewed','paid','overdue').
export async function resolveSendFirstInvoiceItem(
  { progress }: ResolverInput,
): Promise<ResolverResult> {
  if (progress.has_invoice) return { complete: true, reason: 'invoice sent' };
  return { complete: false, reason: 'no invoice sent' };
}
